// Minimal auth helper (safe addition). More logic can be added later.
export function parseAndValidateIdToken(token, slackSeconds = 60) {
    if (!token) return null;
    try {
        const payloadBase64 = token.split('.')[1];
        if (!payloadBase64) return null;
        const payloadJson = atob(payloadBase64);
        const payload = JSON.parse(payloadJson);
        const now = Math.floor(Date.now() / 1000);
        if ((payload.exp || 0) > now + slackSeconds) return token;
    } catch { }
    return null;
}

export function getValidStoredToken() {
    return parseAndValidateIdToken(localStorage.getItem('google_id_token'));
}
